'use client';

import { createRouteNotFound } from '@/components/route-states/route-not-found';

export default createRouteNotFound({ variant: 'guest' });
